import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import reportWebVitals from './reportWebVitals.ts';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './Auth/AuthConfig.tsx';
import { PublicClientApplication } from '@azure/msal-browser';
import store from './Redux/Store.tsx';
import { Provider } from 'react-redux';
import { LicenseManager } from "ag-grid-enterprise";

LicenseManager.setLicenseKey(process.env.REACT_APP_AGGRID_LICENSE ?? "");

const pca = new PublicClientApplication(msalConfig);

async function bootstrap() {
  try {
    await pca.initialize();

    const response = await pca.handleRedirectPromise();

    if (response) {
      pca.setActiveAccount(response.account);
    }

    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );

    root.render(
      <MsalProvider instance={pca}>
        <Provider store={store}>
          <App />
        </Provider>
      </MsalProvider>
    );
  } catch (error) {
    console.error("Redirect or initialization error:", error);
  }
}

bootstrap();
reportWebVitals();
